import { Button, Grid, IconButton } from "@material-ui/core";
import { DeleteOutline } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { DatePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { CheckCircleOutline } from "@mui/icons-material";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";

export interface BookingClosureProps {
  value: string;
  onChange: (value: string) => void;
  onDelete: () => void;
}

export interface BookingClosureCollectionProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export function BookingClosure(props: BookingClosureProps) {
  const { value } = props;
  const [date, setDate] = useState(value);
  const [hasChanges, setHasChanges] = useState(false);

  const handleConferma = () => {
    props.onChange(date);
    setHasChanges(false);
  };

  const handleDelete = () => {
    props.onDelete();
  };

  const handleSetDate = (value: MaterialUiPickersDate) => {
    if (value) {
      // value is an instance of javascript Date type
      // I want to send to the BE only the Date in ISO
      // toISOString includes also the time and timezone
      // so, I use luxon to create the exact input
      const v = DateTime.fromJSDate(value).toISODate();
      if (!v) return;
      setDate(v);
      props.onChange(v);
      console.debug(`new date is => ${v}`);
    }
  };

  useEffect(() => {
    if (date === value) {
      setHasChanges(false);
    } else {
      setHasChanges(true);
    }
  }, [date]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={8}>
        <DatePicker
          value={date}
          onChange={handleSetDate}
          label="Data di chiusura"
          format="dd/MM/yyyy"
          style={{ width: "100%" }}
        ></DatePicker>
      </Grid>
      <Grid item xs={12} md={4}>
        {hasChanges && (
          <IconButton
            aria-label="Conferma"
            size="medium"
            onClick={handleConferma}
            style={{ marginTop: "4px" }}
          >
            <CheckCircleOutline fontSize={"inherit"} />
          </IconButton>
        )}
        <IconButton
          aria-label="Elimina"
          size="medium"
          onClick={handleDelete}
          style={{ marginTop: "4px" }}
        >
          <DeleteOutline fontSize={"inherit"} />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export function BookingClosureCollection(props: BookingClosureCollectionProps) {
  const { value } = props;
  const [items, setItems] = useState(value);

  const handleChange = (newItem: string, index: number) => {
    const newCollection = [...items];
    newCollection.splice(index, 1, newItem);
    setItems(newCollection);
    props.onChange(newCollection);
  };

  const handleNewItem = () => {
    const newItem: string = DateTime.now().toISODate();
    const newCollection = [...items, newItem];
    setItems(newCollection);
    props.onChange(newCollection);
  };

  const handleDelete = (index: number) => {
    const newCollection = [...items];
    newCollection.splice(index, 1);
    setItems(newCollection);
    props.onChange(newCollection);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container>
          {value.map((item, index) => {
            return (
              <Grid item sm={6} md={4} lg={3} key={`closure${index}`}>
                <BookingClosure
                  value={item}
                  onChange={(v) => handleChange(v, index)}
                  onDelete={() => handleDelete(index)}
                />
              </Grid>
            );
          })}
        </Grid>
        {value.length === 0 && (
          <Grid item xs={12}>
            <Alert severity="info">Nessun giorno di chiusura inserito</Alert>
          </Grid>
        )}
      </Grid>
      <Grid item xs={12}>
        <Button type="button" onClick={handleNewItem} variant={"outlined"}>
          (+) Aggiungi un giorno di chiusura
        </Button>
      </Grid>
    </Grid>
  );
}
